<template>
  <div class="page-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>
        <span class="page-title">繁星计划</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item>节点设置</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="page-content" shadow="never">
      <div class="page-actions">
        <create></create>
        <setrules></setrules>
        <nodemany></nodemany>
        <span>
          新人初始化时间：{{ times | moment('YYYY-MM-DD') }}
          <i class="el-icon-edit" @click="setTime" />
        </span>
        <span>
          节点奖励：{{ percent }}
          <i class="el-icon-edit" @click="setPercents" />
        </span>
      </div>
      <list @refresh="getList"></list>
    </el-card>
  </div>
</template>

<script>
import './store';
import { mapState, mapActions } from 'vuex';
import List from './components/list';
import Create from './components/create';
import Setrules from './components/setrules';
import Nodemany from './components/nodemany';

export default {
  name: 'foundationRecords',
  data() {
    return {
      times: '',
      percent: 0,
      params: {
        type: 0
      }
    };
  },
  components: {
    List,
    Create,
    Setrules,
    Nodemany
  },
  computed: {
    ...mapState('setnode', ['pagination', 'records'])
  },
  methods: {
    ...mapActions('foundationProject', ['setPercent', 'getpercent']),
    ...mapActions('setnode', ['getRecords', 'gettime', 'settime']),
    handleSearch() {
      this.getList();
    },
    getList(data = {}) {
      this.getRecords({
        ...this.params,
        ...this.pagination,
        ...data
      });
    },
    setTime() {
      this.$prompt('设置初始化时间', '提示', {
        inputType: 'date'
      }).then(({ value }) => {
        this.settime({ time: Date.parse(value) }).then(() => {
          this.$message.success('操作成功！');
          this.gettime().then(res => {
            this.times = Number(res.data);
          });
        });
      });
    },
    setPercents() {
      this.$prompt('设置节点奖励（0-1）', '提示', {
        inputValidator: value => {
          return !value || !value.trim() ? '奖励数' : true;
        }
      }).then(({ value }) => {
        this.setPercent({ aDouble: value }).then(() => {
          this.$message.success('操作成功！');
          this.getpercent().then(res => {
            this.percent = res.data;
          });
        });
      });
    }
  },
  created() {
    this.getList();
    this.gettime().then(res => {
      this.times = Number(res.data);
    });
    this.getpercent().then(res => {
      this.percent = res.data;
    });
  }
};
</script>
